import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import TableHeaderCell from '../../../../../newEditor/tablePart/tableHeaderCell';
import { TableHeaderRow } from '../../../../../newEditor/tablePart/styles';

function Header({
  activeCol, highlights, onToggleHighlight,
}) {
  return (
    <TableHeaderRow className="m-0 px-1 fs--1 d-flex">
      <Col xl={4} lg={4}>
        <Row>
          <Col className="px-0 text-center border">
            <span>Газоспоживаюче обладнання</span>
          </Col>
        </Row>
        <Row>
          <Col xl={9} lg={9} className="px-0">

            <TableHeaderCell
              className="text-center text-xl-left"
              active={activeCol === 'gas_equpmanet'}
              highlighted={highlights.includes('gas_equpmanet')}
              onToggleHighlight={() => onToggleHighlight('gas_equpmanet')}
            >
              обладнання
            </TableHeaderCell>
          </Col>

          <Col xl={3} lg={3} className="px-0">

            <TableHeaderCell
              className="text-center text-xl-left"
              active={activeCol === 'amount'}
              highlighted={highlights.includes('amount')}
              onToggleHighlight={() => onToggleHighlight('amount')}
            >
              Кількість
            </TableHeaderCell>
          </Col>
        </Row>
      </Col>

      <Col className="px-0 border-start">
        <Row>
          <Col className="px-0 text-center border-bottom">
            <span>Димовідвідна труба</span>
          </Col>
        </Row>
        <Row>
          <Col className="px-0">

            <TableHeaderCell
              className="text-center text-xl-left"
              active={activeCol === 'connect_tube'}
              highlighted={highlights.includes('connect_tube')}
              onToggleHighlight={() => onToggleHighlight('connect_tube')}
            >
              Матеріал
            </TableHeaderCell>
          </Col>

          <Col xl={4} lg={4} className="px-0">

            <TableHeaderCell
              className="text-center text-xl-left"
              active={activeCol === 'area_connect_tube'}
              highlighted={highlights.includes('area_connect_tube')}
              onToggleHighlight={() => onToggleHighlight('area_connect_tube')}
            >
              Перетин
            </TableHeaderCell>
          </Col>

          <Col xl={2} lg={2} className="px-0">

            <TableHeaderCell
              className="text-center text-xl-left"
              active={activeCol === 'length_smoke_tube'}
              highlighted={highlights.includes('length_smoke_tube')}
              onToggleHighlight={() => onToggleHighlight('length_smoke_tube')}
            >
              Довжина вертикальної ділянки
            </TableHeaderCell>
          </Col>

          <Col xl={2} lg={2} className="px-0">

            <TableHeaderCell
              className="text-center text-xl-left"
              active={activeCol === 'turns_smoke_tube'}
              highlighted={highlights.includes('turns_smoke_tube')}
              onToggleHighlight={() => onToggleHighlight('turns_smoke_tube')}
            >
              Кількість поворотів
            </TableHeaderCell>
          </Col>
        </Row>
      </Col>

    </TableHeaderRow>
  );
}

Header.propTypes = {
  // fields: fieldsPropTypes.isRequired,
  activeCol: PropTypes.string,
  highlights: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleHighlight: PropTypes.func.isRequired,
};

Header.defaultProps = {
  activeCol: null,
};

export default Header;
